import { Box, Button, Link, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import PageNotfound from '../../../../assets/page_not_found.svg';
import { palette, spaces } from '../../../../assets/styles/themes/tokens';
import { emailAddresses, platformUrl } from '../../../../constants';
import useScreenSize from '../../../../utils/useScreenSize';

const ErrorConfirmationPage: React.FC = () => {
	const { t } = useTranslation();
	const { isXsScreen } = useScreenSize();

	return (
		<Box
			data-testid="error-confirmation-page"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				paddingY: spaces.xxxxxl,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					width: isXsScreen ? 'auto' : '600px',
				}}
			>
				<Box
					sx={{
						paddingTop: spaces.xxl,
						paddingBottom: spaces.xxxxxl,
						paddingX: spaces.xxxl,
						'& svg': {
							width: '100%',
							height: '100%',
							objectFit: 'cover',
						},
					}}
				>
					<PageNotfound />
				</Box>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						gap: spaces.lg,
					}}
				>
					<Typography
						variant="h4"
						sx={{
							color: palette.text.primary,
							textAlign: 'center',
						}}
					>
						{t('Something went wrong')}
					</Typography>
					<Typography
						variant="body1"
						sx={{
							color: palette.text.secondary,
							textAlign: 'center',
							overflowWrap: 'anywhere',
						}}
					>
						{t(
							'You may have already created your account, or the link has expired.' +
								' Please try logging in to meinUnterricht directly.' +
								' If the problem persists, contact us at '
						)}
						<Link href={`mailto:${emailAddresses.support}`} underline="none">
							{emailAddresses.support}
						</Link>
						{'.'}
					</Typography>
					<Button
						variant="contained"
						color="primary"
						size="large"
						href={platformUrl}
						data-testid="error-confirmation-platform-button"
					>
						{t('To the platform')}
					</Button>
				</Box>
			</Box>
		</Box>
	);
};
export default ErrorConfirmationPage;
